import { Injectable, NgZone } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Router} from "@angular/router";
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable, BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  userData: any; // User data var
  public currentUser: any;
  public userStatus: string;
  public userStatusChanges: BehaviorSubject<string>
  constructor(private ngZone: NgZone, private afAuth: AngularFireAuth, private firestore: AngularFirestore , private router: Router) {
    this.userStatusChanges = new BehaviorSubject<string>(this.userStatus);
     this.afAuth.authState.subscribe(user => {
      if (user) {
        this.userData = user; // Setting up user data in userData var
        localStorage.setItem('user', JSON.stringify(this.userData));
        JSON.parse(localStorage.getItem('user')|| '{}');
      } else {
        localStorage.setItem('user', '{}');
        JSON.parse(localStorage.getItem('user')|| '{}');
      }
    })
  }

  setUserStatus(userStatus: any): void {
    this.userStatus = userStatus;
    this.userStatusChanges.next(userStatus);
  }
  addDays(date: Date, days: any): Date {
    date.setDate(date.getDate() + parseInt(days));
    return date;
  }
  signUp(name:string, email:string, phoneno:string, password:string){

    this.afAuth.createUserWithEmailAndPassword(email, password)
     .then((userResponse)=>{
       let user = {
        id: userResponse.user.uid,
        name: name,
        phoneno: phoneno,
        username: userResponse.user.email,
        role: "user",
        approval_status: "Requested",
        createddate: new Date(),
        enddate: this.addDays(new Date(), 14)
       }

      //  this.firestore.collection("users").add(user)
      //  .then(user => {
      //   user.get().then(x => {
      //     console.log("xdata"+x.data());
      //     this.currentUser = x.data();
      //     this.setUserStatus(this.currentUser);
      //     this.router.navigate(["/"]);
      //   })
      //  }).catch(err => {
      //    console.log(err);
      //  })
       this.firestore.collection("users").doc(userResponse.user.email).set(user)
       .then(user => {
        // user.get().then(x => {
        //   console.log(x.data());
        //   this.currentUser = x.data();
        //   this.setUserStatus(this.currentUser);
          this.router.navigate(["/"]);
        // })
       })
      //  .catch(err => {
      //    console.log(err);
      //  })

     })
     .catch((err)=>{
        console.log("An error ocurred: ", err);
     })

    }
    employeeSignUp(name:string, email:string,password:string){
      this.afAuth.createUserWithEmailAndPassword(email, password)
      .then((userResponse)=>{
        let user = {
         id: userResponse.user.uid,
         name: name,
         phoneno: password,
         username: userResponse.user.email,
         role: "employee",
         approval_status: "Approved",
         createddate: new Date(),
         enddate: this.addDays(new Date(), 14)
        }

        this.firestore.collection("users").doc(userResponse.user.email).set(user)
        .then(user => {

          //  this.router.navigate(["/"]);
        })

      })
      .catch((err)=>{
         console.log("An error ocurred: ", err);
      })
    }
    agentSignUp(name:string, email:string, phoneno:string){

      this.afAuth.createUserWithEmailAndPassword(email, phoneno)
       .then((userResponse)=>{
         let user = {
          id: userResponse.user.uid,
          name: name,
          phoneno: phoneno,
          username: userResponse.user.email,
          role: "agent",
          approval_status: "Approved",
          createddate: new Date(),
          enddate: this.addDays(new Date(), 14)
         }

         this.firestore.collection("users").doc(userResponse.user.email).set(user)
         .then(user => {

            this.router.navigate(["/"]);
         })

       })
       .catch((err)=>{
          console.log("An error ocurred: ", err);
       })

      }


    login(email: string, password: string) {

      this.afAuth.signInWithEmailAndPassword(email, password)
      .then((user)=>{
        this.firestore.collection("users").ref.where("username", "==", user.user.email).onSnapshot(snap =>{
          snap.forEach(userRef => {
            console.log("userRef", userRef.data());
            this.currentUser = userRef.data();
            this.setUserStatus(this.currentUser)
            console.log("userRef.data()",userRef.data()["role"]);
            if(userRef.data()["role"] === "user") {
              this.ngZone.run(() => {
                this.router.navigate(['/card-creator']);
              });
            }else if(userRef.data()["role"] === "admin"){
              this.ngZone.run(() => {
                this.router.navigate(['/admin']);
              });
            }else if(userRef.data()["role"] === "agent"){
              this.ngZone.run(() => {
                this.router.navigate(['/agent']);
              });
            }else if(userRef.data()["role"] === "employee"){
              this.ngZone.run(() => {
                this.router.navigate(['/employee']);
              });
              // this.router.navigate(["/employee"]);
            }else{
              this.router.navigate(["/"]);
            }
          })
        })

      }).catch(err => err)
  }
//   async send_mail(){
//     let transporter = nodemailer.createTransport({
//       sendmail: true,
//       newline: 'windows',
//       logger: false
//   });
//   let message = {
//     from: 'Andris <jagadeeswaranbe2015@gmail.com>',

//     // Comma separated list of recipients
//     to: 'Andris Reinman <jagdishpv@outlook.com>',

//     // Subject of the message
//     subject: 'Nodemailer is unicode friendly ✔',

//     // plaintext body
//     text: 'Hello to myself!',

//     // HTML body
//     html:
//         '<p><b>Hello</b> to myself <img src="cid:note@example.com"/></p>' +
//         '<p>Here\'s a nyan cat for you as an embedded attachment:<br/><img src="cid:nyan@example.com"/></p>',

// };

// let info = await transporter.sendMail(message);
// console.log('Message sent successfully as %s', info.messageId);
//   }
  forgotpassword(email : string){
  // this.send_mail();

    return this.afAuth.sendPasswordResetEmail(email)
    .then(() => {
      window.alert('Password reset email sent, check your inbox. Sometimes it will be in JUNK/SPAM');
    }).catch((error) => {
      window.alert(error)
    })

  }
  logOut(){
    this.afAuth.signOut()
    .then(()=>{
      localStorage.removeItem('user');
      localStorage.clear();
      //set current user to null to be logged out
      this.currentUser = null;
      //set the listenener to be null, for the UI to react
      this.setUserStatus(null);
      this.ngZone.run(() => this.router.navigate(["/login"]));

    }).catch((err) => {
      console.log(err);
    })
  }


  userChanges(){
    this.afAuth.onAuthStateChanged(currentUser => {
      if(currentUser){
        this.firestore.collection("users").ref.where("username", "==", currentUser.email).onSnapshot(snap =>{
          snap.forEach(userRef => {
            this.currentUser = userRef.data();
            //setUserStatus
            this.setUserStatus(this.currentUser);
            console.log(this.userStatus)

            if(userRef.data()["role"] === "user") {
              this.ngZone.run(() => this.router.navigate(["/card-creator"]));
            }else if(userRef.data()["role"] === "admin"){
              this.ngZone.run(() => this.router.navigate(["/admin"]));

            }else if(userRef.data()["role"] === "agent"){
              this.ngZone.run(() => this.router.navigate(["/agent"]));

            }else if(userRef.data()["role"] === "employee"){
              this.ngZone.run(() => this.router.navigate(["/employee"]));

            }else{
              this.ngZone.run(() => this.router.navigate(["/"]));
            }
          })
        })
      }else{
        //this is the error you where looking at the video that I wasn't able to fix
        //the function is running on refresh so its checking if the user is logged in or not
        //hence the redirect to the login
        this.ngZone.run(() => this.router.navigate(["/"]));
      }
    })
  }

}
